// FI-1869: shells hide their legacy left rails when the horizon nav owns
// navigation (site_theme 'new' or its dark variant 'midnight'); classic
// keeps them untouched.
export default {
  computed: {
    horizonNavActive() {
      const t = this.$store.state.profile.site_theme
      return t === 'new' || t === 'midnight'
    },
  },
}
